module.exports = __webpack_public_path__ + "static/img/product-un-sale.76058a03.png";